/** 
 * A duplex communication channel between windows using BroadcastChannel.
 * To be initialised on both sides with the same key.
 */
export class BroadcastChannelController<TMainEvent, TChildEvent> {
  private channel: BroadcastChannel;

  constructor(public key: string) {
    this.channel = new BroadcastChannel(`watchful-${key}`);
  }

  sendMessageToMain(event: TMainEvent) {
    this.channel.postMessage({
      __type: this.key,
      __to: 'main',
      ...event
    });
  }

  sendMessageToChild(event: TChildEvent) {
    this.channel.postMessage({
      __type: this.key,
      __to: 'child',
      ...event
    });
  }

  registerHandlerMain(fn: (event: TMainEvent) => void) {
    const handler = (event: MessageEvent) => {
      const data = event.data;
      if (data.__type === this.key && data.__to === 'main') {
        // Remove internal fields before passing to handler
        const { __type, __to, ...rest } = data;
        fn(rest as TMainEvent);
      }
    };

    this.channel.addEventListener('message', handler);
    return () => this.channel.removeEventListener('message', handler);
  }

  registerHandlerChild(fn: (event: TChildEvent) => void) {
    const handler = (event: MessageEvent) => {
      const data = event.data;
      if (data.__type === this.key && data.__to === 'child') {
        // Remove internal fields before passing to handler
        const { __type, __to, ...rest } = data;
        fn(rest as TChildEvent);
      }
    };

    this.channel.addEventListener('message', handler);
    return () => this.channel.removeEventListener('message', handler);
  }
}